const APP_NAME = process.env.APP_NAME || "priceManagement";
const STORE_DEBUG = process.env.STORE_DEBUG === "true";
const AUTH_CONFIG_CLIENT = process.env.AUTH_CONFIG_CLIENT || "portal";
const APP_DEV: boolean = process.env.APP_DEV === "true";
const CONFIGURATION_STORE_NAME =
  process.env.CONFIGURATION_STORE_NAME || "price-management";
const APP_PATH = process.env.APP_PATH || "price-management";
const APP_URL = process.env.APP_URL || "http://localhost:3011/";
const API_URL =
  process.env.API_URL ||
  "https://dev.prices.api.fbusinesscenter.com/price-mgmt-backend";
const API_REST_URL =
  process.env.API_RESTFUL_URL ||
  "https://dev.prices.api.fbusinesscenter.com/rpm-restful-api-bff";
const API_URL_VERSION = process.env.API_URL_VERSION || "v1";
const INTERNET_STORE_ID = process.env.INTERNET_STORE_ID || "100051";
const TENANTS_GROUPS_PREFIX = process.env.TENANTS_GROUPS_PREFIX || "PRCMGMT";
const TENANTS_GROUPS_CORP_PREFIX =
  process.env.TENANTS_GROUPS_CORP_PREFIX || "CORP";
const CREATED_BY_EVENT_LISTENER_PRICE_SAVER =
  process.env.CREATED_BY_EVENT_LISTENER_PRICE_SAVER ||
  "event-listener-price-saver";
const CREATED_BY_LEGACY_SYSTEM =
  process.env.CREATED_BY_LEGACY_SYSTEM || "legacySystem";
const IS_PRODUCTION = process.env.IS_PRODUCTION || false;
const OMNICHANNEL_PREFIX = process.env.TENANT_REGEX || "Omnichannel-Retail";

export {
  APP_NAME,
  STORE_DEBUG,
  AUTH_CONFIG_CLIENT,
  APP_DEV,
  CONFIGURATION_STORE_NAME,
  APP_PATH,
  API_URL,
  APP_URL,
  API_URL_VERSION,
  INTERNET_STORE_ID,
  TENANTS_GROUPS_PREFIX,
  TENANTS_GROUPS_CORP_PREFIX,
  CREATED_BY_EVENT_LISTENER_PRICE_SAVER,
  CREATED_BY_LEGACY_SYSTEM,
  API_REST_URL,
  IS_PRODUCTION,
  OMNICHANNEL_PREFIX,
};
